import { render } from "./LeaveBulkActionModal.vue?vue&type=template&id=cb71c5e8&scoped=true"
import script from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"
export * from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"

import "./LeaveBulkActionModal.vue?vue&type=style&index=0&id=cb71c5e8&scoped=true&lang=css"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb71c5e8"]])

export default __exports__